import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { FaBoxOpen } from 'react-icons/fa';
import { Input } from 'reactstrap';
import i18n from '@/utils/i18n';

type SelectManualAmountsAmountsProps = {
  amount: string;
  packingUnit: number;
  setAmount: Dispatch<SetStateAction<string>>;
};

const SelectManualAmountsAmounts = ({
  amount,
  packingUnit,
  setAmount,
}: SelectManualAmountsAmountsProps) => {
  const [boxAmount, setBoxAmount] = useState('0'); // Container Station
  const [containerTypeAmount, setContainerTypeAmount] = useState(
    packingUnit.toString(),
  );
  const [sumAmount, setSumAmount] = useState('0');

  useEffect(() => {
    const newAmount = Number(boxAmount) * Number(containerTypeAmount);

    setSumAmount(newAmount.toString());
  }, [boxAmount, containerTypeAmount]);

  useEffect(() => {
    if (sumAmount !== amount) {
      setAmount(sumAmount);
    }
  }, [sumAmount]);

  return (
    <>
      <div className="d-flex justify-content-end flex-row">
        <div className="align-self-center">
          <FaBoxOpen style={{ width: '25px' }} />
        </div>
        <Input
          title={i18n.t('OrderFulfillment:titleBoxCount')}
          style={{ maxWidth: '80px' }}
          type="number"
          value={boxAmount}
          min={0}
          onChange={(event) => {
            let value = event.currentTarget.value;
            if (Number(value) < 0) {
              value = '0';
            }

            setBoxAmount(value);
          }}
        />
        <div
          className="align-self-center text-center"
          style={{ width: '20px' }}
        >
          x
        </div>
        <Input
          title={i18n.t('OrderFulfillment:titleContainerInBox')}
          style={{ maxWidth: '80px' }}
          type="number"
          value={containerTypeAmount}
          min={0}
          onChange={(event) => {
            let value = event.currentTarget.value;
            if (Number(value) < 0) {
              value = '0';
            }

            setContainerTypeAmount(value);
          }}
        />
      </div>
      <div className="d-flex justify-content-end flex-row">
        <div
          className="align-self-center text-center"
          style={{ width: '20px' }}
        >
          =
        </div>
        <Input
          title={i18n.t('OrderFulfillment:titleContainerTotal')}
          style={{ maxWidth: '80px' }}
          type="number"
          value={sumAmount}
          min={0}
          onChange={(event) => {
            let value = event.currentTarget.value;
            if (Number(value) < 0) {
              value = '0';
            }

            setSumAmount(value);
          }}
        />
      </div>
    </>
  );
};

export default SelectManualAmountsAmounts;
